import React, { useState, useEffect } from 'react';

import GpsGraphsModule from '../modules/GpsGraphsModule';
import './Box.css';

const QiGpsGraphsBox = ({user, isSmallScreen}) => {

    return (
        <div className={isSmallScreen ? "standard-box-screen-small" : "standard-box"}>

            <h4></h4>

            <GpsGraphsModule
                user={user}
                isSmallScreen={isSmallScreen}
            />

        </div>
    );
};

export default QiGpsGraphsBox;

